import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { SubscriptionService } from '../../subscription.service';
import { Router, ActivatedRoute } from '@angular/router';
import { LoaderService } from '../../../loader.service';
import { SharedService } from '../../../shared/shared.service';
import { AuthService } from '../../../auth.service';
import { ConfirmDialogService } from '../../../shared/confirm-dialog/confirm-dialog.service';
import { AlertDialogService } from '../../../shared/alert-dialog/alert-dialog.service';
import { subscriptionOperationFailureAlert, subscriptionUpdateSuccessAlert } from '../../subscription.create-alert';
import { AuthzAccessHintService } from '../../../shared/authz-access-hint/authz-access-hint.service';
import { AUTHZ_FEATURES } from '../../../constants/permissions';
import { permissionsForFeature } from '../../../utils/permission.utils';
var ViewAccessFeeComponent = /** @class */ (function () {
    function ViewAccessFeeComponent(subscriptionService, route, loaderService, sharedService, router, accessRights, dialogService, alertDialogService, authzAccessHintService) {
        this.subscriptionService = subscriptionService;
        this.route = route;
        this.loaderService = loaderService;
        this.sharedService = sharedService;
        this.router = router;
        this.accessRights = accessRights;
        this.dialogService = dialogService;
        this.alertDialogService = alertDialogService;
        this.authzAccessHintService = authzAccessHintService;
        this.planData = {};
        this.canDeactivate = false;
        this.authzAccessHint = null;
        this.cityMap = {};
        this.cityIdNameMap = {};
        this.serviceMap = {};
        this.userSelectors = [];
        this.zones = [];
        this.services = [];
    }
    Object.defineProperty(ViewAccessFeeComponent.prototype, "showDeactivate", {
        get: function () {
            return this.canDeactivate && this.planData && this.planData.active;
        },
        enumerable: true,
        configurable: true
    });
    ViewAccessFeeComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var editPermission, _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        editPermission = (permissionsForFeature(AUTHZ_FEATURES.BILLING_PLANS, this.accessRights.getAuthzPanels()) || {}).edit;
                        this.canDeactivate = this.accessRights.isAuthorizedFor(editPermission, AUTHZ_FEATURES.BILLING_PLANS);
                        _a = this;
                        return [4 /*yield*/, this.authzAccessHintService.getAccessHintData('billingPlans')];
                    case 1:
                        _a.authzAccessHint = _b.sent();
                        return [4 /*yield*/, this.withLoader(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var planId, res, cityId, serviceIdToNameMap_1, userSelectorDetails, zonesIds, zonesDetails, err_1;
                                var _this = this;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.fetchAllCities()];
                                        case 1:
                                            _a.sent();
                                            planId = this.route.snapshot.paramMap.get('id');
                                            _a.label = 2;
                                        case 2:
                                            _a.trys.push([2, 9, , 10]);
                                            return [4 /*yield*/, this.subscriptionService.getBillingPlan(planId).toPromise()];
                                        case 3:
                                            res = _a.sent();
                                            this.planData = res;
                                            cityId = res.city;
                                            this.planData.city = this.cityIdNameMap[cityId] || "NA";
                                            serviceIdToNameMap_1 = {};
                                            return [4 /*yield*/, this.sharedService.fetchServices(cityId)
                                                    .toPromise()
                                                    .then(function (result) {
                                                    return result.data.map(function (sd) {
                                                        if (sd && sd.service && sd.service._id) {
                                                            serviceIdToNameMap_1[sd.service._id] = { name: sd.service.name };
                                                        }
                                                    });
                                                })];
                                        case 4:
                                            _a.sent();
                                            this.planData.services = this.planData.services.map(function (serviceId) { return serviceIdToNameMap_1[serviceId].name; }).join(',');
                                            if (!this.planData.userSelectors) return [3 /*break*/, 6];
                                            return [4 /*yield*/, Promise.all(this.planData.userSelectors.map(function (selector) {
                                                    return _this.sharedService.getUserSelectorDetails(selector).toPromise();
                                                }))];
                                        case 5:
                                            userSelectorDetails = _a.sent();
                                            this.userSelectors = userSelectorDetails.map(function (response) { return response.name; });
                                            this.planData.userSelectors = this.userSelectors.join(',');
                                            _a.label = 6;
                                        case 6:
                                            if (!this.planData.zones) return [3 /*break*/, 8];
                                            zonesIds = this.planData.zones;
                                            return [4 /*yield*/, this.sharedService.fetchBulkZones(zonesIds)
                                                    .toPromise()
                                                    .then(function (result) {
                                                    return result.geolayers.map(function (layer) { return layer.name; }).join(',');
                                                })];
                                        case 7:
                                            zonesDetails = _a.sent();
                                            this.planData.zones = zonesDetails;
                                            _a.label = 8;
                                        case 8: return [3 /*break*/, 10];
                                        case 9:
                                            err_1 = _a.sent();
                                            console.log(err_1);
                                            return [3 /*break*/, 10];
                                        case 10: return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ViewAccessFeeComponent.prototype.withLoader = function (cb) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, , 2, 3]);
                        this.loaderService.openLoading();
                        return [4 /*yield*/, cb()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        this.loaderService.closeLoading();
                        return [7 /*endfinally*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ViewAccessFeeComponent.prototype.fetchAllCities = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var citiesRes, citiesData, _i, citiesData_1, city;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sharedService.fetchCities().toPromise()];
                    case 1:
                        citiesRes = _a.sent();
                        citiesData = citiesRes.data.cities;
                        for (_i = 0, citiesData_1 = citiesData; _i < citiesData_1.length; _i++) {
                            city = citiesData_1[_i];
                            this.cityMap[city.displayName] = city._id;
                            this.cityIdNameMap[city._id] = city.displayName;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ViewAccessFeeComponent.prototype.showAlertBox = function (options) {
        this.alertDialogService.open(options);
    };
    ViewAccessFeeComponent.prototype.deactivateAccessFeeRule = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    title: "Are you sure to deactivate the " + this.planData.planName + " plan ?",
                    message: "You are about to deactivate accessfee " + this.planData.planName,
                    cancelText: 'Cancel',
                    confirmText: 'Yes, Proceed'
                };
                this.dialogService.open(options);
                this.dialogService.confirmed().subscribe(function (confirmed) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var resp, error_1;
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!confirmed) {
                                    return [2 /*return*/];
                                }
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, this.subscriptionService.updateBillingPlan(this.planData.id || this.route.snapshot.paramMap.get('id'), { active: false }).toPromise()];
                            case 2:
                                resp = _a.sent();
                                this.planData.active = false;
                                this.showAlertBox(subscriptionUpdateSuccessAlert(resp));
                                return [3 /*break*/, 4];
                            case 3:
                                error_1 = _a.sent();
                                this.showAlertBox(subscriptionOperationFailureAlert(error_1));
                                return [3 /*break*/, 4];
                            case 4: return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    return ViewAccessFeeComponent;
}());
export { ViewAccessFeeComponent };
